import {
    ErrorGeneralMessage,
    ErrorMessageRequestTimedOut,
    ErrorMessageServerUnavailable,
    ErrorMessageFeatureNotEnabled,
    ErrorMessagePreviousEditInProgress,
    ErrorMessageNotLatestEmail,
} from '../../strings.locstring.json';
import loc from 'owa-localize';
import GWSRequestErrorInfo from '../../store/schema/GWSRequestErrorInfo';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import { ResponseStatus } from '../../helpers/GriffinConstants';

import { HttpStatusCode } from 'owa-http-status-codes';

export default function handleSaveEditableResponse(
    response: any,
    gwsRequestErrorInfo: GWSRequestErrorInfo,
    perfDataPoint: PerformanceDatapoint,
    onError?: (clientErrorMessage: string, status: DatapointStatus, error?: Error) => void,
    onSuccess?: () => void
) {
    if (response == null) {
        onUnknownServerError(perfDataPoint, gwsRequestErrorInfo, onError);
    } else if (response === DatapointStatus.Timeout) {
        onError(loc(ErrorMessageRequestTimedOut), DatapointStatus.Timeout);
    } else if (response.Body.ResponseClass == ResponseStatus.Success) {
        onSuccess();
    } else if (gwsRequestErrorInfo.statusCode == HttpStatusCode.ServiceUnavailable) {
        onError(
            loc(ErrorMessageServerUnavailable),
            DatapointStatus.RequestNotComplete,
            Error(gwsRequestErrorInfo.serverErrorMessage)
        );
    } else if (response.Body.ResponseClass == ResponseStatus.Error) {
        switch (gwsRequestErrorInfo.statusCode) {
            case HttpStatusCode.NotImplemented:
                onError(loc(ErrorMessageFeatureNotEnabled), DatapointStatus.ServerError);
                break;
            case HttpStatusCode.Conflict:
                onError(loc(ErrorMessagePreviousEditInProgress), DatapointStatus.ServerError);
                break;
            case HttpStatusCode.Forbidden:
                onError(loc(ErrorMessageNotLatestEmail), DatapointStatus.ServerError);
                break;
            default:
                onUnknownServerError(perfDataPoint, gwsRequestErrorInfo, onError);
        }
    }
}

function onUnknownServerError(
    perfDataPoint: PerformanceDatapoint,
    gwsRequestErrorInfo: GWSRequestErrorInfo,
    onError?: (errorMessage: string, status: DatapointStatus, error?: Error) => void
): void {
    perfDataPoint.addCustomData({ serverStatusCode: gwsRequestErrorInfo.statusCode });
    onError(
        loc(ErrorGeneralMessage),
        DatapointStatus.ServerError,
        Error(gwsRequestErrorInfo.serverErrorMessage)
    );
}
